<template>
  <b-container>
    <b-row>
      <b-col>
        <h5 class="mb-5" align="center">코더스하이 주요실적</h5>
        <ul class="timeline">
          <li v-for="history in codershighHistories" :key="history.title">
            {{ history.date }}
            <br />
            {{ history.title }}
            <ul>
              <li v-for="item in history.description" :key="item">{{ item }}</li>
            </ul>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      codershighHistories: [
        {
          date: " 2018. 7.",
          description: [
            "고려대학교 대학교육개발원 여름방학 특강 운영",
            "중앙대학교 iOS 특성화 과정 여름방학 특강 운영",
            "서울여자대학교 Programming GURU 1 여름방학 특강 운영",
            "서울여자대학교 Programming GURU 2여름방학 특강 운영"
          ]
        },
        {
          date: " 2018. 5.",
          description: ["숙명여자대학교 WINE 프로그램 iOS 앱 개발 과정 운영"]
        },
        {
          date: " 2018. 4.",
          description: ["SAP Fiori for iOS 과정 운영"]
        },
        {
          date: " 2018. 3.",
          description: [
            "한양대학교 컴퓨터학과 [소프트웨어 스튜디오] 운영",
            "서울대학교 정보문화학과 [인터페이스프로그래밍] 커리큘럼 제공",
            "연세대학교 UIC IID [애플리케이션 프로토타이핑] 커리큘럼 제공"
          ]
        },
        {
          date: "2018. 1.",
          description: [
            "고려대학교 대학교육개발원 겨울방학 특강 운영",
            "중앙대학교 iOS 특성화 과정 겨울방학 특강 운영",
            "서울여자대학교 Programming GURU 2 겨울방학 특강 운영",
            "동국대학교 청년기업가센터 iOS 앱 개발 특강운영"
          ]
        },
        {
          date: "2017. 11.",
          description: ["동국대학교 청년기업가센터 [런투스위프트]특강운영"]
        },
        {
          date: "2017. 9.",
          description: [
            "서울대학교 정보문화학과 [고급인터페이스프로그래밍] 커리큘럼 제공",
            "애플코리아와 ‘코더스하이 커리큘럼 회의’ 이벤트 개최",
            "미래교실캠퍼스(고교대안학교) [런투스위프트] 특강운영"
          ]
        },
        {
          date: "2017. 7.",
          description: [
            "고려대학교 대학교육개발원 여름방학 특강 운영",
            "중앙대학교 iOS 특성화 과정 여름방학 특강 운영",
            "서울여자대학교 Programming GURU 1 여름방학 특강 운영",
            "서강대학교 앱 프로토타입 여름방학 특강 운영"
          ]
        },
        {
          date: "2017. 6.",
          description: ["LINE+ 앱 표준화 팀 프로토타입 고도화 제작 계약"]
        },
        {
          date: "2017. 5.",
          description: ["(주)SK [iOS 앱 개발 고급] 과정 운영"]
        },
        {
          date: "2017. 4.",
          description: ["(주)SK [iOS 앱 개발 기본] 과정 운영"]
        },
        {
          date: "2017. 3.",
          description: [
            "한양대학교 컴퓨터학과 [소프트웨어 스튜디오] 운영",
            "서울대학교 정보문화학과 [인터페이스프로그래밍]",
            "커리큘럼 제공 연세대학교 UIC IID [애플리케이션 프로토타이핑] 커리큘럼 제공"
          ]
        },
        {
          date: "2017. 1.",
          description: [
            "고려대학교 대학교육개발원 겨울방학 특강 운영",
            "중앙대학교 iOS 특성화 과정 겨울방학 특강 운영",
            "서울여자대학교 iOS 앱 개발 겨울방학 특강 운영"
          ]
        },
        {
          date: "2016. 12.",
          description: [
            "LINE+ 앱 표준화 팀 프로토타입 제작 계약",
            "LINE+ 앱 표준화 팀 인턴십 프로그램 제공"
          ]
        },
        {
          date: "2016. 9.",
          description: [
            "한양대학교 컴퓨터학과 [융합소프트웨어프로젝트] 운영",
            "서울대학교 정보문화학과 [고급인터페이스프로그래밍] 커리큘럼 제공",
            "연세대학교 UIC IID [애플리케이션 프로토타이핑] 커리큘럼 제공",
            "동국대학교 멀티미디어공학과 [HCI] 커리큘럼 제공"
          ]
        },
        {
          date: "2016. 7.",
          description: [
            "고려대학교 대학교육개발원 여름방학 특강 운영",
            "인천대학교 컴퓨터공학과 여름방학 특강 운영"
          ]
        },
        {
          date: "2016. 6.",
          description: [
            "멀티캠퍼스(전 삼성SDS) [아이폰 앱 개발 기본] 커리큘럼 제공"
          ]
        },
        {
          date: "2016. 6.",
          description: ["LINE+ 앱 표준화 팀 컨설팅"]
        },
        {
          date: "2016. 5.",
          description: ["법인설립"]
        }
      ]
    };
  }
};
</script>

<style>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
</style>
